import { render, staticRenderFns } from "./cIntakeReport.vue?vue&type=template&id=84ffe974&scoped=true"
import script from "./cIntakeReport.vue?vue&type=script&lang=js"
export * from "./cIntakeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ffe974",
  null
  
)

export default component.exports